"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What is included in your Managed IT Services?",
  answer: "Our comprehensive managed services include 24/7 network monitoring, proactive security patching, cloud infrastructure management, and dedicated helpdesk support. We act as your internal IT department, ensuring your systems are always optimized and secure."
}, {
  question: "How do you handle data security and compliance?",
  answer: "We implement multi-layered security protocols, including advanced encryption, firewall management, and regular vulnerability assessments. Our solutions are designed to meet industry-specific compliance standards like SOC2, HIPAA, and GDPR."
}, {
  question: "What is your typical response time for critical issues?",
  answer: "For critical system failures, we guarantee a response within 15 minutes. Our team is available around the clock to ensure that any infrastructure disruptions are addressed immediately to minimize downtime for your business operations."
}, {
  question: "Can you help with cloud migration and strategy?",
  answer: "Absolutely. We specialize in seamless migrations to AWS, Azure, and private cloud environments. Our team develops a custom roadmap to transition your legacy systems while maintaining data integrity and operational continuity."
}, {
  question: "Do you offer scalable solutions for growing businesses?",
  answer: "Yes, our infrastructure is built for scalability. Whether you are adding new users or expanding to multiple locations, our flexible service models allow you to scale your IT resources up or down based on your current business requirements."
}];
export default function CommonQuestions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237373" id="frequently-asked-questions" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="mx-auto max-w-[800px] px-6 md:px-8">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tighter">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Find answers to common inquiries about our managed IT solutions, infrastructure support, and technical expertise.
          </p>
        </div>

        <div ref={accordionRef} className={`transition-all duration-700 delay-200 ease-out ${isAccordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/60 py-2 transition-colors duration-300 data-[state=open]:bg-slate-50/50 dark:data-[state=open]:bg-slate-900/50">
                <AccordionTrigger className="text-left text-lg md:text-xl font-semibold font-default text-foreground hover:text-secondary hover:no-underline py-4 group">
                  <span className="flex items-center gap-3">
                    <span className="h-2 w-2 rounded-full bg-primary shrink-0" />
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground font-default leading-relaxed pb-6 pt-2 px-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}